import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CustomValidationError } from "go-form/services/types";
import { UpsellApi } from "../../../../../../../../../../../services/Api/Organization/types";
import UpsellFormConditions from "./UpsellFormConditions";
import UpsellFormEntitiesTable from "./UpsellFormEntitiesTable";

interface Props {
	form: UseFormReturn<UpsellApi>;
	setIsItemsTableVisible: React.Dispatch<React.SetStateAction<boolean>>;
	setErrors: React.Dispatch<React.SetStateAction<CustomValidationError<any>[]>>;
	setAreConditionsVisible: React.Dispatch<React.SetStateAction<boolean>>;
	areConditionsVisible: boolean;
	isItemsTableVisible: boolean;
}

const UpsellFormRules = ({
	form,
	setErrors,
	areConditionsVisible,
	setAreConditionsVisible,
	setIsItemsTableVisible,
	isItemsTableVisible,
}: Props) => {
	const { t } = useTranslation();

	return (
		<fieldset className="form-group no-gutters">
			<h5>{t("modules.upsell.field.rules.title")}</h5>
			<UpsellFormEntitiesTable
				form={form}
				setErrors={setErrors}
				isVisible={isItemsTableVisible}
				setIsVisible={setIsItemsTableVisible}
			/>
			<UpsellFormConditions
				form={form}
				setAreConditionsVisible={setAreConditionsVisible}
				areConditionsVisible={areConditionsVisible}
			/>
		</fieldset>
	);
};

export default UpsellFormRules;
